<template>
    <ModalBase :minWidth="'80%'" :maxWidth="'80%'">
        <loader :loading="loading" v-if="loading"></loader>
        <div v-if="zones.length > 0">
            <p class="ff-light title-modal">{{ $t("menuHeader.selectZone") }}</p>
            <div class="d-flex justify-content-between flex-wrap modalFlex">
                <div
                    class="brandWrap flexContainer jc-c fd-c pointer"
                    v-if="!isDisabledZone(zone.id)"
                    v-for="(zone, index) in zones"
                    :key="zone.id"
                    @click="saveZone(zone);"
                >
                    <div :id="'hover' + index" class="brandLogo" :class="[selectZone === zone.name.toLowerCase() ? '_selectedZone' : '', '']">
                        <p>{{ zone.name | trimModal }}</p>
                    </div>
                </div>
            </div>
        </div>
    </ModalBase>
</template>

<script>
import ModalBase from "./ModalBase";
import { setUser } from "@/directives/setUser.js";
import httpService from "@/components/service";
import { bus } from "@/main";
import currentZone from "@/services/currentZone";
import cacheService from "@/services/cache";
import loader from "@/components/loader/loader";
import { mapActions } from "vuex";

export default {
    name: "ModalZone",
    data() {
        return {
            loading: false,
            zones: [],
            brandZones: [],
            selectZone: (cacheService.getCurrentZoneName() || "").toLowerCase()
        };
    },
    components: { loader, ModalBase },
    directives: {
        setUser
    },
    methods: {
        ...mapActions("forecast", { populateAdminBrandZones: "populateAdminBrandZones" }),
        saveZone(zone) {
            bus.$emit("zoneSaved", zone.name);
            bus.$emit("zoneShortSaved", zone.abbreviation);
            bus.$emit("closeModal", false);
            bus.$emit("resetOption", "null");
            currentZone.save(zone, this.$accessUser);
        },
        async getZones() {
            try {
                this.loading = true;
                this.brandZones = await this.populateAdminBrandZones({ reload: true, notPersist: true });
                this.zones = (await httpService.get("/zones/list?limit=200")).data;
                this.loading = false;
            } catch (e) {
                this.dialogError(e);
            }
        },
        isDisabledZone(zoneId) {
            const brandZone = this.brandZones.find(bz => bz.zone.id === zoneId);
            if (!brandZone) {
                return true;
            }
            return !this.brandZones.find(bz => bz.zone.id === zoneId).active;
        }
    },
    created() {
        this.getZones();
    },
    filters: {
        trimModal: value => {
            if (value.length < 61) return value;
            return value.substring(0, 60) + "...";
        }
    }
};
</script>

<style lang="scss">
//@import "../../assets/css/themes.scss";
.modalFlex {
    &:after {
        content: "";
        flex: auto;
    }
    .brandWrap {
        position: relative;
        width: 20%;
        padding: 0 6px;
        height: 80px;
        min-width: 180px;

        .brandLogo {
            height: 80px;
            display: flex;
            align-items: center;
            padding: 6px;
            justify-content: center;
            text-align: center;
            p {
                margin: 0;
                font-size: 1.5rem !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalZone.vue?7a001cb2